import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import './StatusPill.css';

// Every status string in use across the app, mapped to one of five
// semantic variants. Unknown statuses fall back to "neutral" rather
// than throwing, so new backend enums never render broken.
const STATUS_VARIANT = {
  // neutral
  todo: 'neutral',
  upcoming: 'neutral',
  not_applicable: 'neutral',
  dormant: 'neutral',
  inactive: 'warning',
  low: 'neutral',

  // priority
  medium: 'info',
  high: 'warning',
  urgent: 'danger',

  // info
  in_progress: 'info',
  'in-progress': 'info',
  onboarding: 'info',
  proposed: 'info',

  // warning
  in_review: 'warning',
  review: 'warning',
  changes_requested: 'warning',
  pending: 'warning',
  'on-hold': 'warning',
  // Blocked ON THE CLIENT — something to chase, not something that failed,
  // so warning rather than danger.
  'waiting-client': 'warning',

  // success
  done: 'success',
  completed: 'success',
  filed: 'success',
  active: 'success',
  approved: 'success',

  // danger
  overdue: 'danger',
  late_filed: 'danger',
  rejected: 'danger',
  cancelled: 'danger',
  left: 'danger',
  closed: 'danger',
};

const formatLabel = (status) =>
  status
    .replace(/[_-]/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

function StatusPill({ status, variant, label }) {
  const reduceMotion = useReducedMotion();
  const resolvedVariant = variant || STATUS_VARIANT[status] || 'neutral';
  const resolvedLabel = label || (status ? formatLabel(status) : '');

  return (
    <span className={`ds-pill ds-pill-${resolvedVariant}`}>
      <span className="ds-pill-dot" />
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={resolvedLabel}
          className="ds-pill-label"
          initial={reduceMotion ? false : { opacity: 0, y: 3 }}
          animate={{ opacity: 1, y: 0 }}
          exit={reduceMotion ? undefined : { opacity: 0, y: -3 }}
          transition={{ duration: 0.15, ease: [0.4, 0, 0.2, 1] }}
        >
          {resolvedLabel}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}

export default StatusPill;
